<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="90%" top="5vh">
    <div ref="dia_box" v-loading="dialogLoding">
      <baseInfo
        ref="baseInfo"
        :isChakan="isChakan"
        :isEdit="isEdit"
        :system="system"
        @setSellerId="setSellerId"
        @changeSku="changeSku"
        @changeName="changeName"
      ></baseInfo>
      <upload-pictures
        ref="UploadPicturesRef"
        :isChakan="isChakan"
        :isEdit="isEdit"
        :system="system"
        :upload-action="uploadAction"
        @ImgList="onUploadImgList"
      />
      <shuxin
        ref="shuxing"
        :isChakan="isChakan"
        :isEdit="isEdit"
        :system="system"
        @setCategoryId="setCategoryId"
        @setBottomBiantiArr="setBottomBiantiArr"
        @addToBianti="addToBianti"
      ></shuxin>
      <laiyuan
        ref="laiyuan"
        :isChakan="isChakan"
        :isEdit="isEdit"
        :system="system"
      ></laiyuan>
      <description
        ref="description"
        :imgList="productImgArr"
        :isChakan="isChakan"
        :isEdit="isEdit"
        :system="system"
      ></description>
      <annexFile
        ref="annexFile"
        :isChakan="isChakan"
        :isEdit="isEdit"
        :system="system"
      ></annexFile>
      <bianti
        ref="bianti"
        :isChakan="isChakan"
        :system="system"
        :isEdit="isEdit"
        :img-select-list="productImgArr"
        @changeReamrk="changeReamrk"
        @addImageList="addImageList"
        @changeTopAttr="changeTopAttr"
      ></bianti>
      <wuliu ref="wuliu" :isChakan="isChakan" :isEdit="isEdit" :system="system">
      </wuliu>
    </div>
    <span slot="footer" style="margin-top: 60px">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button
        :loading="loadingStatus"
        type="primary"
        @click="saveChanpin(false)"
        v-if="system == 5 && !isChakan"
        >保 存</el-button
      >
      <el-button
        :loading="loadingStatus"
        type="primary"
        @click="saveAndfabu"
        style="margin-right: 30px"
        v-if="system == 5 && !isChakan"
        >保存并发布</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { ajaxPost, Baseurl, ajaxGet } from "../../api/api/api";
import description from "./components/description.vue";
import annexFile from "./components/annexFile.vue";
import onlineBianti from "./components/onlineBianti.vue";
import uploadPictures from "./components/uploadPictures.vue";
import wuliu from "./components/wuliu.vue";
import baseInfo from "./components/baseInfo.vue";
import shuxin from "./components/shuxing.vue";
import laiyuan from "./components/laiyuan.vue";
import bianti from "./components/bianti.vue";
export default {
  name: "createProduct",
  components: {
    baseInfo,
    uploadPictures,
    shuxin,
    wuliu,
    onlineBianti,
    description,
    annexFile, //附件
    laiyuan,
    bianti,
  },
  data() {
    return {
      loadingStatus: false,
      dialogLoding: false,
      str: "",
      onlineEdit: false,
      dialogVisible: false,
      uploadAction: Baseurl + "imageController/uploadImage",
      //图片数组,用于下图的勾选
      productImgArr: [],
      //编辑时顶部元素
      topArr: [],
      //编辑时变体元素
      bottomArr: [],
      //编辑状态
      isEdit: false,
      editId: "",
      variant_id: "",
    };
  },
  props: {
    isChakan: {
      type: Boolean,
      default: false,
    },
    system: {
      type: Number,
      default: 5,
    },
    title: {
      type: String,
      default: "添加产品",
    },
  },
  created() {
    this.str = JSON.parse(localStorage.getItem("role"));
  },
  methods: {
    openDialog(dianpuList) {
      this.isEdit = false;
      this.dialogVisible = true;
      this.sellerId = "";
      this.productImgArr = [];
      this.$nextTick(() => {
        this.$refs.baseInfo.initData(dianpuList);
        this.$refs.UploadPicturesRef.imgListSelect = [];
        this.$refs.shuxing.initData();
        this.$refs.laiyuan.initData();
        this.$refs.description.initData();
        this.$refs.bianti.initData();
        this.$refs.wuliu.initData();
        this.$refs.annexFile.initData();
      });
    },
    //编辑打开
    editDialog(id, dianpuList) {
      this.editId = id;
      this.openDialog(dianpuList);
      this.isEdit = true;
      this.loading = this.$loading({
        target: this.$refs.dia_box,
        text: "努力加载中...",
        background: "rgba(218,218,238,0.2)",
      });
      this.dialogLoding = true;

      const API = Baseurl + "allegroProductInfo/getAllegroProductDetail/" + id;
      ajaxGet(API).then((res) => {
        this.dialogLoding = false;
        let allegroProduct = res.data.data.allegroProduct;
        let allegroOfferList = res.data.data.allegroOfferList;
        if (allegroProduct.afterSalesServices) {
          allegroProduct.afterSalesServices = JSON.parse(
            allegroProduct.afterSalesServices
          );
        }
        if (allegroProduct.delivery) {
          allegroProduct.delivery = JSON.parse(allegroProduct.delivery);
        }
        if (allegroProduct.description) {
          allegroProduct.description = JSON.parse(allegroProduct.description);
        }
        if (allegroProduct.location) {
          allegroProduct.location = JSON.parse(allegroProduct.location);
        }
        if (allegroProduct.offerParameters) {
          allegroProduct.offerParameters = JSON.parse(
            allegroProduct.offerParameters
          );
        }
        if (allegroProduct.productParameters) {
          allegroProduct.productParameters = JSON.parse(
            allegroProduct.productParameters
          );
        }
        if (allegroProduct.variantParameters) {
          allegroProduct.variantParameters = JSON.parse(
            allegroProduct.variantParameters
          );
        }
        //附件
        if (allegroProduct.attachmentsInfo) {
          allegroProduct.attachmentsInfo = JSON.parse(
            allegroProduct.attachmentsInfo
          );
          if (this.$refs.annexFile) {
            this.$refs.annexFile.fileList =
              allegroProduct.attachmentsInfo || [];
          }
        }
        let kongArr = [];
        let allBottomValue = [];
        if (allegroOfferList && allegroOfferList.length > 0) {
          allegroOfferList.forEach((item) => {
            if (item.additionalMarketplaces) {
              item.additionalMarketplaces = JSON.parse(
                item.additionalMarketplaces
              );
            }
            if (item.productParameters) {
              item.productParameters = JSON.parse(item.productParameters);
            } else {
              item.productParameters = [];
            }
            if (item.sellingMode) {
              item.sellingMode = JSON.parse(item.sellingMode);
            }
            if (item.stock) {
              item.stock = JSON.parse(item.stock);
            }
            //再循环一次避免变体二维数组,某一个变体漏填,导致遗漏数据
            item.productParameters.forEach((itemProduct) => {
              if (!kongArr.includes(itemProduct.id)) {
                kongArr.push(itemProduct.id);
                allBottomValue.push(itemProduct);
              }
            });
          });
        }
        this.variant_id = allegroProduct.variantId;
        this.$refs.baseInfo.formData.sellerId = allegroProduct.sellerId;
        this.$refs.baseInfo.isEditSellerId = allegroProduct.sellerId
          ? true
          : false;
        this.setSellerId(allegroProduct.sellerId);
        this.$refs.baseInfo.formData.sku = allegroProduct.sku;
        this.$refs.baseInfo.isEditSku = allegroProduct.sku ? true : false;
        this.$refs.bianti.ParentSKU = allegroProduct.sku;
        this.$refs.baseInfo.formData.name = allegroProduct.name;
        this.$refs.bianti.ParentName = allegroProduct.name;
        this.$refs.shuxing.setName(allegroProduct.name);
        this.$refs.baseInfo.formData.checked = allegroProduct.enPublication;
        this.productImgArr = allegroProduct.imageList;
        this.$refs.shuxing.formData.categoryId = allegroProduct.categoryId;
        this.$refs.shuxing.isEditLeimu = allegroProduct.categoryId
          ? true
          : false;
        this.$refs.shuxing.formData.categoryName = allegroProduct.cnFullName;
        let productParameters = allegroProduct.productParameters
          ? allegroProduct.productParameters
          : [];
        let offerParameters = allegroProduct.offerParameters
          ? allegroProduct.offerParameters
          : [];
        let topValue = productParameters.concat(offerParameters);
        this.getAttrList(
          allegroProduct.categoryId,
          topValue,
          allBottomValue,
          allegroOfferList
        );
        this.$refs.UploadPicturesRef.imgListSelect = allegroProduct.imageList;
        this.$refs.laiyuan.remark = allegroProduct.remarks;
        allegroProduct.sourceLinkList =
          allegroProduct.sourceLinkList && allegroProduct.sourceLinkList.length
            ? allegroProduct.sourceLinkList
            : [];
        this.$refs.laiyuan.blue_point = allegroProduct.sourceLinkList.map(
          (item) => {
            return {
              value: item,
            };
          }
        );
        if (
          allegroProduct.description &&
          allegroProduct.description.sections &&
          allegroProduct.description.sections.length > 0
        ) {
          this.$refs.description.descList =
            allegroProduct.description.sections.map((item) => {
              const list = item.items;
              const returnObj = {
                descType: list?.map((ele) => ele.type)?.join("&"),
              };
              list.map((ele, i) => {
                const { type, content, url } = ele;
                if (type === "TEXT") {
                  returnObj.content = content;
                } else if (type === "IMAGE") {
                  if (!returnObj.imageUrl) {
                    returnObj.imageUrl = url;
                  } else {
                    returnObj[`imageUrl${i}`] = url;
                  }
                }
              });
              return returnObj;
            });
        }
        this.$refs.wuliu.formData.city =
          allegroProduct.location && allegroProduct.location.city
            ? allegroProduct.location.city
            : undefined;
        this.$refs.wuliu.formData.countryCode =
          allegroProduct.location && allegroProduct.location.countryCode
            ? allegroProduct.location.countryCode
            : undefined;
        this.$refs.wuliu.formData.postCode =
          allegroProduct.location && allegroProduct.location.postCode
            ? allegroProduct.location.postCode
            : undefined;
        this.$refs.wuliu.formData.province =
          allegroProduct.location && allegroProduct.location.province
            ? allegroProduct.location.province
            : undefined;
        this.$refs.wuliu.formData.chuliTime =
          allegroProduct.delivery && allegroProduct.delivery.handlingTime
            ? allegroProduct.delivery.handlingTime
            : undefined;
        this.$refs.wuliu.formData.jiagebiao =
          allegroProduct.delivery &&
          allegroProduct.delivery.shippingRates &&
          allegroProduct.delivery.shippingRates.id
            ? allegroProduct.delivery.shippingRates.id
            : undefined;
        this.$refs.wuliu.formData.jiageName =
          allegroProduct.delivery &&
          allegroProduct.delivery.shippingRates &&
          allegroProduct.delivery.shippingRates.jiageName
            ? allegroProduct.delivery.shippingRates.jiageName
            : undefined;
        this.$refs.wuliu.formData.tuihuo =
          allegroProduct.afterSalesServices &&
          allegroProduct.afterSalesServices.returnPolicy &&
          allegroProduct.afterSalesServices.returnPolicy.id
            ? allegroProduct.afterSalesServices.returnPolicy.id
            : undefined;
        this.$refs.wuliu.formData.tuihuoName =
          allegroProduct.afterSalesServices &&
          allegroProduct.afterSalesServices.returnPolicy &&
          allegroProduct.afterSalesServices.returnPolicy.name
            ? allegroProduct.afterSalesServices.returnPolicy.name
            : undefined;
        this.$refs.wuliu.formData.baoxiu =
          allegroProduct.afterSalesServices &&
          allegroProduct.afterSalesServices.warranty &&
          allegroProduct.afterSalesServices.warranty.id
            ? allegroProduct.afterSalesServices.warranty.id
            : undefined;
        this.$refs.wuliu.formData.baoxiuName =
          allegroProduct.afterSalesServices &&
          allegroProduct.afterSalesServices.warranty &&
          allegroProduct.afterSalesServices.warranty.name
            ? allegroProduct.afterSalesServices.warranty.name
            : undefined;
          this.$refs.wuliu.formData.invoice = allegroProduct.invoice;
          let invoiceLists = [];
          for (let index = 0; index < JSON.parse(allegroProduct.taxSettings).rates.length; index++) {
            invoiceLists.push({
              label: JSON.parse(allegroProduct.taxSettings).rates[index].countryCode,
              value: JSON.parse(allegroProduct.taxSettings).rates[index].rate
            })
          }
          this.$refs.wuliu.setCategoryId(allegroProduct.categoryId,invoiceLists)
          // this.$refs.wuliu.invoiceLists = invoiceLists;
          // console.log(this.$refs.wuliu.invoiceLists,'this.$refs.wuliu.invoiceLists');
          this.$refs.wuliu.rates = JSON.parse(allegroProduct.taxSettings).rates,
          this.$refs.wuliu.formData.taxRateTheme = JSON.parse(allegroProduct.taxSettings).subject,
          this.$refs.wuliu.formData.taxExemption = JSON.parse(allegroProduct.taxSettings).exemption,
        this.dialogLoding = false;
        this.loading.close();
      });
    },
    //修改/查看获取属性
    getAttrList(categoryId, topValueList, bottomValueList, allegroOfferList) {
      const url =
        Baseurl + "/allegroCategory/getCategoryParameterAndDictionary";
      ajaxPost(url, { categoryId: categoryId }).then((res) => {
        const attrList = res.data.data;
        this.topArr = [];
        this.bottomArr = [];
        attrList.forEach((item) => {
          this.setAttributeValue(item, topValueList, bottomValueList);
        });
        this.$refs.shuxing.topShuxingArr = [...this.topArr];
        this.$refs.bianti.setBianjiArr(this.bottomArr, allegroOfferList);
      });
    },
    //设置属性值
    setAttributeValue(arrItem, topValueList, bottomValueList) {
      if (arrItem.restrictions) {
        arrItem.restrictions = JSON.parse(arrItem.restrictions);
      }
      if (arrItem.options) {
        arrItem.options = JSON.parse(arrItem.options);
      }
      if (arrItem.type == "dictionary") {
        const filterFlag =
          arrItem.name === "Marka" ||
          arrItem.name === "Producent" ||
          arrItem.name === "Producent części" ||
          arrItem.name === "Wydawnictwo";
        let selectDropList = arrItem.parameterDictionaryList; //选择的下拉数据
        if (filterFlag) {
          selectDropList =
            (arrItem.dictionary && JSON.parse(arrItem.dictionary)) || [];
        }

        arrItem.parameterDictionaryList = selectDropList.map((itemMap) => {
          return {
            label:
              itemMap.value +
              (itemMap.cnValue ? "(" + itemMap.cnValue + ")" : ""),
            value: filterFlag ? itemMap.id : itemMap.dictionaryId,
            pinjieName: itemMap.value,
            parameterId: arrItem.parameterId,
          };
        });
      }
      //属于顶部主属性
      let setTopValue = topValueList.find(
        (itemFind) => itemFind.id == arrItem.parameterId
      );
      //属于变体属性
      let setBottomValue = bottomValueList.find(
        (itemFind) => itemFind.id == arrItem.parameterId
      );
      //顶部元素 variantsAllowed 是false 并且 不是225693 并且不是点击加号到底部的变体元素,属于上部元素
      if (
        !(arrItem.options && arrItem.options.variantsAllowed) &&
        arrItem.parameterId != "225693" &&
        !setBottomValue
      ) {
        //如果已经赋值,需要赋值逻辑,否则按照 属性页面方法来赋值
        if (arrItem.type == "dictionary") {
          //这个是多选
          if (arrItem.restrictions && arrItem.restrictions.multipleChoices) {
            arrItem.fieldValue = setTopValue ? setTopValue.valuesIds : [];
          } else {
            arrItem.fieldValue = setTopValue ? setTopValue.valuesIds[0] : "";
          }
          if (
            arrItem.options.customValuesEnabled &&
            this.isInnyStart(
              arrItem.fieldValue,
              arrItem.parameterDictionaryList
            )
          ) {
            if (setTopValue?.values) {
              arrItem.values = setTopValue.values[0];
            }
          } else {
            arrItem.values = undefined;
          }
        } else {
          arrItem.fieldValue = setTopValue ? setTopValue.values[0] : "";
        }
        this.topArr.push({ ...arrItem });
      } else {
        this.bottomArr.push({ ...arrItem });
      }
    },
    //修改sku
    changeSku(val) {
      this.$refs.bianti.ParentSKU = val;
    },
    //修改name
    changeName(val) {
      this.$refs.bianti.ParentName = val;
      this.$refs.shuxing.setName(val);
    },
    // 产品图片子组件 中上传的图片列表
    onUploadImgList(ImgList) {
      this.productImgArr = ImgList;
    },
    //保存按钮
    saveChanpin(isFabu) {
      let inputBitianObj = this.returnInputLength();
      //检测是否有变体重复，有的话，标红
      if (this.$refs.bianti.returnBianti()) {
        this.$message("变体信息不可重复，请修改变体属性");
        return;
      }
      if (!this.$refs.baseInfo.formData.sku) {
        this.$message("父SKU不能为空");
        return;
      }
      if (
        this.$refs.bianti.tableList.some((item) => {
          return !item.SKU;
        })
      ) {
        this.$message("变体属性SKU不能为空");
        return;
      }
      if (isFabu && !inputBitianObj.bitian) {
        this.$message("请先填写完成页面必填项");
      }
      let isChongfuBianti = true;
      //判断变体是否重复的
      if (this.$refs.bianti.attrErweiList.length > 0) {
        isChongfuBianti =
          [...new Set(this.$refs.bianti.attrErweiList)].length ==
          this.$refs.bianti.attrErweiList.length;
      }
      if (!isChongfuBianti) {
        this.$message("变体属性重复，不可提交");
        return;
      }
      this.saveLoadding = true;
      let productParametersJsonArray = [];
      let offerParametersJsonArray = [];
      let sourceLinkList = this.$refs.laiyuan.blue_point.map((item) => {
        return item.value;
      });
      this.$refs.description.descList = this.$refs.description.descList.filter(
        (itemfilter) => {
          return (
            (itemfilter.descType == "TEXT" && itemfilter.content) ||
            (itemfilter.descType == "IMAGE" && itemfilter.imageUrl) ||
            (itemfilter.descType == "IMAGE&TEXT" &&
              itemfilter.imageUrl &&
              itemfilter.content) ||
            (itemfilter.descType == "TEXT&IMAGE" &&
              itemfilter.imageUrl &&
              itemfilter.content) ||
            (itemfilter.descType == "IMAGE&IMAGE" &&
              itemfilter.imageUrl &&
              itemfilter.imageUrl1)
          );
        }
      );
      let sections = this.$refs.description.descList.map((item) => {
        let returnContent;
        if (item.descType == "TEXT") {
          returnContent = {
            items: [
              {
                type: "TEXT",
                content: item.content,
              },
            ],
          };
        } else if (item.descType == "IMAGE") {
          returnContent = {
            items: [
              {
                type: "IMAGE",
                url: item.imageUrl,
              },
            ],
          };
        } else if (item.descType === "IMAGE&TEXT") {
          returnContent = {
            items: [
              {
                type: "IMAGE",
                url: item.imageUrl,
              },
              {
                type: "TEXT",
                content: item.content,
              },
            ],
          };
        } else if (item.descType === "TEXT&IMAGE") {
          returnContent = {
            items: [
              {
                type: "TEXT",
                content: item.content,
              },
              {
                type: "IMAGE",
                url: item.imageUrl,
              },
            ],
          };
        } else if (item.descType === "IMAGE&IMAGE") {
          returnContent = {
            items: [
              {
                type: "IMAGE",
                url: item.imageUrl,
              },
              {
                type: "IMAGE",
                url: item.imageUrl1,
              },
            ],
          };
        }
        return returnContent;
      });
      let descriptionJson = {
        sections: sections,
      };
      let locationJson = {
        city: this.$refs.wuliu.formData.city,
        countryCode: this.$refs.wuliu.formData.countryCode,
        postCode: this.$refs.wuliu.formData.postCode,
        province: this.$refs.wuliu.formData.province,
      };
      //处理时间
      let deliveryJson = {
        handlingTime: this.$refs.wuliu.formData.chuliTime,
        shippingRates: {
          id: this.$refs.wuliu.formData.jiagebiao,
          name: this.$refs.wuliu.formData.jiageName,
        },
      };
      let afterSalesServicesJson = {
        returnPolicy: {
          id: this.$refs.wuliu.formData.tuihuo,
          name: this.$refs.wuliu.formData.tuihuoName,
        },
        warranty: {
          id: this.$refs.wuliu.formData.baoxiu,
          name: this.$refs.wuliu.formData.baoxiuName,
        },
      };
      let variantParametersJsonArray = [];

      this.$refs.shuxing.topShuxingArr.forEach((item) => {
        //放入product
        if (item.options && item.options.describesProduct) {
          //下拉,多选且有值
          if (
            item.type == "dictionary" &&
            item.restrictions &&
            item.restrictions.multipleChoices
          ) {
            if (item.fieldValue && item.fieldValue.length > 0) {
              productParametersJsonArray.push(this.returnPushObj(item));
            }
            //input输入
          } else {
            if (
              item.fieldValue ||
              item.fieldValue == "0" ||
              item.fieldValue == "false"
            ) {
              productParametersJsonArray.push(this.returnPushObj(item));
            }
          }
        } else {
          //下拉,多选且有值
          if (
            item.type == "dictionary" &&
            item.restrictions &&
            item.restrictions.multipleChoices
          ) {
            if (item.fieldValue && item.fieldValue.length > 0) {
              offerParametersJsonArray.push(this.returnPushObj(item));
            }
            //input输入
          } else {
            if (
              item.fieldValue ||
              item.fieldValue == "0" ||
              item.fieldValue == "false"
            ) {
              offerParametersJsonArray.push(this.returnPushObj(item));
            }
          }
        }
      });
      let allegroOfferList = [];
      this.$refs.bianti.tableList.forEach((item, tableIndex) => {
        let productParametersJsonArrayBianti = [];
        let offerParametersJsonArrayBianti = [];
        this.$refs.bianti.headerList.forEach((itemHeader, index) => {
          //放入product
          if (itemHeader.options && itemHeader.options.describesProduct) {
            //下拉,多选且有值
            if (
              itemHeader.type == "dictionary" &&
              itemHeader.restrictions &&
              itemHeader.restrictions.multipleChoices
            ) {
              if (
                this.$refs.bianti.attrErweiList[tableIndex][index].value &&
                this.$refs.bianti.attrErweiList[tableIndex][index].value
                  .length > 0
              ) {
                let pushObj = this.returnBiantiPushObj(
                  itemHeader,
                  this.$refs.bianti.attrErweiList[tableIndex][index].value
                );
                productParametersJsonArrayBianti.push(pushObj);
              }
              //input输入
            } else {
              if (
                this.$refs.bianti.attrErweiList[tableIndex][index].value ||
                this.$refs.bianti.attrErweiList[tableIndex][index].value ==
                  "0" ||
                this.$refs.bianti.attrErweiList[tableIndex][index].value ==
                  "false"
              ) {
                let pushObj = this.returnBiantiPushObj(
                  itemHeader,
                  this.$refs.bianti.attrErweiList[tableIndex][index].value
                );
                productParametersJsonArrayBianti.push(pushObj);
              }
            }
          } else {
            //下拉,多选且有值
            if (
              itemHeader.type == "dictionary" &&
              itemHeader.restrictions &&
              itemHeader.restrictions.multipleChoices
            ) {
              if (
                this.$refs.bianti.attrErweiList[tableIndex][index].value &&
                this.$refs.bianti.attrErweiList[tableIndex][index].value
                  .length > 0
              ) {
                let pushObj = this.returnBiantiPushObj(
                  itemHeader,
                  this.$refs.bianti.attrErweiList[tableIndex][index].value
                );
                offerParametersJsonArrayBianti.push(pushObj);
              }
              //input输入
            } else {
              if (
                this.$refs.bianti.attrErweiList[tableIndex][index].value ||
                this.$refs.bianti.attrErweiList[tableIndex][index].value ==
                  "0" ||
                this.$refs.bianti.attrErweiList[tableIndex][index].value ==
                  "false"
              ) {
                let pushObj = this.returnBiantiPushObj(
                  itemHeader,
                  this.$refs.bianti.attrErweiList[tableIndex][index].value
                );
                offerParametersJsonArrayBianti.push(pushObj);
              }
            }
          }
        });
        let additionalMarketplacesJson = {};
        if (!item.jiekeshoujia && !item.siluofake) {
          additionalMarketplacesJson = null;
        } else {
          if (item.jiekeshoujia) {
            additionalMarketplacesJson["allegro-cz"] = {
              sellingMode: {
                price: {
                  amount: item.jiekeshoujia,
                  currency: "CZK",
                },
              },
            };
          }
          if (item.siluofake) {
            additionalMarketplacesJson["allegro-sk"] = {
              sellingMode: {
                price: {
                  amount: item.siluofake,
                  currency: "CZK",
                },
              },
            };
          }
          if (item.xylshoujia) {
            additionalMarketplacesJson["allegro-hu"] = {
              sellingMode: {
                price: {
                  amount: item.xylshoujia,
                  currency: "HUF",
                },
              },
            };
          }
        }
        let sellingModeJson = null;
        if (item.bolanPrice) {
          sellingModeJson = {
            format: "BUY_NOW",
            price: {
              amount: item.bolanPrice,
              currency: "PLN",
            },
          };
        }
        let itemObj = {
          id: item.id,
          sku: item.SKU,
          categoryId: this.$refs.shuxing.formData.categoryId,
          sellerId: this.$refs.baseInfo.formData.sellerId,
          name: item.name,
          colorPattern: item.color_pattern,
          imageList: item.imageList,
          productParametersJsonArray: productParametersJsonArrayBianti,
          offerParametersJsonArray: offerParametersJsonArrayBianti,
          stockJson: {
            available: item.kucun,
            unit: this.$refs.bianti.kucundanwei,
          },
          language: this.$refs.baseInfo.formData.checked ? "en-US" : "pl-PL",
          sellingModeJson: sellingModeJson,
          additionalMarketplacesJson: additionalMarketplacesJson,
        };
        allegroOfferList.push(itemObj);
      });
      this.$refs.bianti.headerList.forEach((itemHeader, index) => {
        //将EAN排除出去
        if (
          itemHeader.options &&
          itemHeader.options.variantsAllowed &&
          itemHeader.parameterId != "225693"
        ) {
          variantParametersJsonArray.push({
            id: itemHeader.parameterId,
          });
        }
      });
      if (variantParametersJsonArray.length > 0) {
        variantParametersJsonArray.push({
          id: "color/pattern",
        });
      }

      /*附件*/
      const annexFileList = this.$refs.annexFile.fileList || [];
      const attachmentsJsonArray = annexFileList?.map((ele) => {
        return {
          id: ele.id,
        };
      });

      const attachmentsInfoJsonArray = annexFileList;

      let saveParams = {
        allegroProduct: {
          sku: this.$refs.baseInfo.formData.sku,
          categoryId: this.$refs.shuxing.formData.categoryId,
          sellerId: this.$refs.baseInfo.formData.sellerId,
          name: this.$refs.baseInfo.formData.name,
          imageList: this.$refs.UploadPicturesRef.imgListSelect,
          enPublication: this.$refs.baseInfo.formData.checked,
          productParametersJsonArray: productParametersJsonArray,
          offerParametersJsonArray: offerParametersJsonArray,
          sourceLinkList: sourceLinkList,
          remarks: this.$refs.laiyuan.remark,
          descriptionJson: descriptionJson,
          locationJson: locationJson,
          deliveryJson: deliveryJson,
          afterSalesServicesJson: afterSalesServicesJson,
          complete:
            inputBitianObj.shuruInputLength == inputBitianObj.inputLength
              ? 1
              : 0,
          completeness: inputBitianObj.wanchengdu,
          companyId: this.str.company_id,
          staffId: this.str.rid,
          variantParametersJsonArray: variantParametersJsonArray,
          //发布中传2，保存必填完成 1  未全部完成 0
          releaseStatus: inputBitianObj.bitian ? 1 : 0,
          attachmentsJsonArray,
          attachmentsInfoJsonArray,
          // 物流新增销售
          invoice: this.$refs.wuliu.formData.invoice,
          taxSettingsJson:{
            rates: this.$refs.wuliu.rates,
            subject: this.$refs.wuliu.formData.taxRateTheme,
            exemption: this.$refs.wuliu.formData.taxExemption
          }
        },
        allegroOfferList: allegroOfferList,
        saveAndSubmit: !isFabu ? 1 : 2, // 1.保存  2.保存并发布
      };
      if (!this.isEdit) {
        this.loadingStatus = true;
        let apiUrl = "allegroProductInfo/createProduct";
        ajaxPost(Baseurl + apiUrl, saveParams)
          .then((res) => {
            this.loadingStatus = false;
            const { code, message, data } = res.data;
            if (code == 200) {
              this.$message.success(!isFabu ? "保存成功！" : "发布成功！");
              this.dialogVisible = false;
              this.$emit("refreshTable");
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch(function (e) {});
      } else {
        saveParams.allegroProduct.id = this.editId;
        saveParams.allegroOfferList.forEach((item) => {
          if (!item.id) {
            item.variantId = this.variant_id;
          }
        });
        this.loadingStatus = true;
        let apiUrl = "allegroProductInfo/updateAllegroProduct";
        ajaxPost(Baseurl + apiUrl, saveParams)
          .then((res) => {
            this.loadingStatus = false;
            const { code, message, data } = res.data;
            if (code == 200) {
              this.$message.success(!isFabu ? "保存成功！" : "发布成功！");
              this.dialogVisible = false;
              this.$emit("refreshTable");
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch(function (e) {});
      }
    },

    //修改reamrk
    changeReamrk(val) {
      this.$refs.laiyuan.remark = val;
    },
    //保存并发布
    saveAndfabu() {
      this.saveChanpin(true);
    },
    setBottomBiantiArr(arr) {
      this.$refs.bianti.setBiantiList(arr);
    },
    setSellerId(val) {
      this.$refs.wuliu.setSellerId(val);
      this.$refs.shuxing.setSellerId(val);
      this.$refs.annexFile.setSellerId(val);
      this.$refs.UploadPicturesRef.setSellerId(val);
    },
    setCategoryId(val){
      this.$refs.wuliu.setCategoryId(val);
    },
    addImageList(imageList) {
      this.$refs.UploadPicturesRef.biantiaddImgList(imageList);
    },

    //是否inny自定义开头【不区分大小写】
    isInnyStart(field, list) {
      if (field) {
        const str = list
          ?.find((ele) => ele.value === field)
          ?.label?.toLowerCase();
        return str?.startsWith("inny") || str?.startsWith("inna");
      }
      return false;
    },

    //返回一共有多少个输入框
    returnInputLength() {
      //input 总个数
      let inputLength = 15;
      //必填总个数 包括图片
      let bitianLength = 12;
      //变体输入框个数  图片不计算在内
      let tableLength =
        (8 + this.$refs.bianti.headerList.length) *
        this.$refs.bianti.tableList.length;
      let bitianTableLength =
        (3 +
          this.$refs.bianti.headerList.filter((item) => {
            return item.required;
          }).length) *
        this.$refs.bianti.tableList.length;
      //固定长度加 来源url长度
      inputLength =
        inputLength +
        this.$refs.laiyuan.blue_point.length +
        tableLength +
        this.$refs.shuxing.topShuxingArr.length +
        this.$refs.description.descList.length;
      bitianLength =
        bitianLength +
        bitianTableLength +
        this.$refs.shuxing.topShuxingArr.filter((item) => {
          return item.required;
        }).length +
        this.$refs.description.descList.length;
      //以下代码计算输入值长度
      //输入个数
      let shuruInputLength = 0;
      //必填输入个数
      let shuruBitianLength = 0;
      //店铺
      if (this.$refs.baseInfo.formData.sellerId) {
        shuruInputLength += 1;
        shuruBitianLength += 1;
      }
      //sku
      if (this.$refs.baseInfo.formData.sku) {
        shuruInputLength += 1;
        shuruBitianLength += 1;
      }
      //标题
      if (this.$refs.baseInfo.formData.name) {
        shuruInputLength += 1;
        shuruBitianLength += 1;
      }
      //图片
      if (
        this.$refs.UploadPicturesRef.imgListSelect &&
        this.$refs.UploadPicturesRef.imgListSelect.length > 0
      ) {
        shuruInputLength += 1;
        shuruBitianLength += 1;
      }
      //类目
      if (this.$refs.shuxing.formData.categoryId) {
        shuruInputLength += 1;
        shuruBitianLength += 1;
      }
      let headerList = this.$refs.bianti.headerList;
      //计算主属性
      if (this.$refs.shuxing.topShuxingArr.length > 0) {
        this.$refs.shuxing.topShuxingArr.forEach((item) => {
          if (
            (item.type == "float" ||
              item.type == "integer" ||
              item.type == "string") &&
            (item.fieldValue ||
              item.fieldValue == "false" ||
              item.fieldValue == "0")
          ) {
            shuruInputLength += 1;
            if (item.required) {
              shuruBitianLength += 1;
            }
          }
          //下拉选
          if (item.type == "dictionary") {
            //多选
            if (item.restrictions && item.restrictions.multipleChoices) {
              if (item.fieldValue && item.fieldValue.length > 0) {
                shuruInputLength += 1;
                if (item.required) {
                  shuruBitianLength += 1;
                }
              }
              //单选
            } else {
              if (
                item.fieldValue ||
                item.fieldValue == "false" ||
                item.fieldValue == "0"
              ) {
                shuruInputLength += 1;
                if (item.required) {
                  shuruBitianLength += 1;
                }
              }
            }
          }
        });
      }
      //来源url
      for (let i = 0; i < this.$refs.laiyuan.blue_point.length; i++) {
        if (this.$refs.laiyuan.blue_point[i].value) {
          shuruInputLength += 1;
        }
      }
      //来源备注
      if (this.$refs.laiyuan.remark) {
        shuruInputLength += 1;
      }

      //描述
      for (let i = 0; i < this.$refs.description.descList.length; i++) {
        shuruInputLength += 1;
        shuruBitianLength += 1;
        // if (this.$refs.description.descList[i].descType == "TEXT") {
        //   if (this.$refs.description.descList[i].content) {
        //     shuruBitianLength += 1;
        //   }
        // } else if (this.$refs.description.descList[i].descType == "IMAGE") {
        //   if (this.$refs.description.descList[i].imageUrl) {
        //     shuruBitianLength += 1;
        //   }
        // }
      }
      //库存单位
      if (this.$refs.bianti.kucundanwei) {
        shuruInputLength += 1;
        shuruBitianLength += 1;
      }
      this.$refs.bianti.tableList.forEach((item) => {
        //图片
        if (item.imageList && item.imageList.length > 0) {
          shuruInputLength += 1;
        }
        //sku
        if (item.name) {
          shuruInputLength += 1;
          shuruBitianLength += 1;
        }
        //sku
        if (item.SKU) {
          shuruInputLength += 1;
          shuruBitianLength += 1;
        }
        //sku
        if (item.kucun) {
          shuruInputLength += 1;
          shuruBitianLength += 1;
        }
        //波兰站售价
        if (item.bolanPrice || item.bolanPrice == "0") {
          shuruInputLength += 1;
          shuruBitianLength += 1;
        }
        //捷克站售价
        if (item.jiekeshoujia || item.jiekeshoujia == "0") {
          shuruInputLength += 1;
        }
        //斯洛伐克售价
        if (item.siluofake || item.siluofake == "0") {
          shuruInputLength += 1;
        }
        //斯洛伐克售价
        if (item.color_pattern || item.color_pattern == "0") {
          shuruInputLength += 1;
        }
      });
      this.$refs.bianti.attrErweiList.forEach((item) => {
        item.forEach((itemAttr, index) => {
          //input
          if (
            (headerList[index].type == "float" ||
              headerList[index].type == "integer" ||
              headerList[index].type == "string") &&
            (itemAttr.value ||
              itemAttr.value == "0" ||
              itemAttr.value == "false")
          ) {
            //必填
            if (headerList[index].required) {
              shuruBitianLength += 1;
            }
            shuruInputLength += 1;
          }
          //下拉选
          if (headerList[index].type == "dictionary") {
            //多选
            if (
              headerList[index].restrictions &&
              headerList[index].restrictions.multipleChoices
            ) {
              if (itemAttr.value && itemAttr.value.length > 0) {
                shuruInputLength += 1;
                if (headerList[index].required) {
                  shuruBitianLength += 1;
                }
              }
              //单选
            } else {
              if (
                itemAttr.value ||
                itemAttr.value == "false" ||
                itemAttr.value == "0"
              ) {
                shuruInputLength += 1;
                if (headerList[index].required) {
                  shuruBitianLength += 1;
                }
              }
            }
          }
        });
      });
      let eanIndex = this.$refs.bianti.headerList.findIndex((item) => {
        return item.parameterId == "225693";
      });
      //存在EaN
      if (eanIndex != "-1") {
        this.$refs.bianti.tableList.forEach((item, index) => {
          if (this.$refs.bianti.attrErweiList[index][eanIndex].value) {
            shuruBitianLength -= 1;
          }
        });
      }
      //wuliu
      if (this.$refs.wuliu.formData.countryCode) {
        shuruInputLength += 1;
        shuruBitianLength += 1;
      }
      if (this.$refs.wuliu.formData.province) {
        shuruInputLength += 1;
        shuruBitianLength += 1;
      }
      if (this.$refs.wuliu.formData.city) {
        shuruInputLength += 1;
        shuruBitianLength += 1;
      }
      if (this.$refs.wuliu.formData.postCode) {
        shuruInputLength += 1;
        shuruBitianLength += 1;
      }
      if (this.$refs.wuliu.formData.chuliTime) {
        shuruInputLength += 1;
        shuruBitianLength += 1;
      }
      if (this.$refs.wuliu.formData.jiagebiao) {
        shuruInputLength += 1;
        shuruBitianLength += 1;
      }
      if (this.$refs.wuliu.formData.tuihuo) {
        shuruInputLength += 1;
      }
      if (this.$refs.wuliu.formData.baoxiu) {
        shuruInputLength += 1;
      }

      return {
        inputLength: inputLength,
        bitianLength: bitianLength,
        shuruInputLength: shuruInputLength,
        shuruBitianLength: shuruBitianLength,
        bitian: bitianLength == shuruBitianLength,
        wanchengdu: ((shuruInputLength / inputLength) * 100).toFixed(2),
      };
    },
    //增加变体信息
    addToBianti(item) {
      this.$refs.bianti.addBianti(item);
    },
    //子项点击移除变体
    changeTopAttr(attrList) {
      this.$refs.shuxing.addTopAttrList(attrList);
    },
    //根据类型返回push 对象
    returnPushObj(item) {
      let ruturnObj = {};
      //下拉选
      if (item.type == "dictionary") {
        //多选
        if (item.restrictions && item.restrictions.multipleChoices) {
          ruturnObj.id = item.parameterId;
          ruturnObj.valuesIds = item.fieldValue;
        } else {
          ruturnObj.id = item.parameterId;
          ruturnObj.valuesIds = [item.fieldValue];
        }
        if (item.values) {
          ruturnObj.values = [item.values];
        }
      } else {
        ruturnObj.id = item.parameterId;
        ruturnObj.values = [item.fieldValue];
      }
      return ruturnObj;
    },
    //变体根据类型返回push 对象
    returnBiantiPushObj(itemHeader, value) {
      let ruturnObj = {};
      //下拉选
      if (itemHeader.type == "dictionary") {
        //多选
        if (
          itemHeader.restrictions &&
          itemHeader.restrictions.multipleChoices
        ) {
          ruturnObj.id = itemHeader.parameterId;
          ruturnObj.valuesIds = value;
        } else {
          ruturnObj.id = itemHeader.parameterId;
          ruturnObj.valuesIds = [value];
        }
      } else {
        ruturnObj.id = itemHeader.parameterId;
        ruturnObj.values = [value];
      }
      return ruturnObj;
    },
  },
};
</script>
<style lang="scss" scoped></style>
